export default import.meta.ROLLUP_FILE_URL_3AbdWWgtbrvJIojXBl8n$Q;